/**
 * A candidate's name in the list when the row is view only (see
 * `Candidate.listOnly`): a real job seeker in a test workspace, shown so the
 * tester sees real matches but not theirs to open.
 *
 * Plain text, not a link, with a quiet "View only" line under it. The words
 * carry the meaning, so it reads the same to a screen reader as on screen; the
 * lock is decoration. Why it is view only is the test-workspace banner's job,
 * at the top of the page, rather than repeated on every row.
 */

import type { ReactNode } from 'react';
import { LockOutlined } from '@ant-design/icons';

import styles from './index.module.css';

export const VIEW_ONLY_LABEL = 'View only';

const ViewOnlyName = ({ name }: { name: ReactNode }) => (
  <span className={styles.root}>
    <span className={styles.name}>{name}</span>{' '}
    {/* The space keeps "View only" apart from the name wherever the cell is
        read as one string; the flex layout ignores it. */}
    <span className={styles.label}>
      <LockOutlined className={styles.icon} aria-hidden="true" />
      {VIEW_ONLY_LABEL}
    </span>
  </span>
);

export default ViewOnlyName;
